import styled from '@emotion/styled';
import ReactLib from '@owenscorning/react-library';
import React, { useContext } from 'react';

const {
  Connect: {
    FormElements: { Form },
  },
} = ReactLib;

const NextButton = styled.button`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  margin-top: 1.5rem;
  padding: 0.5rem;
  width: 100%;

  :disabled {
    background-color: #d8d8d8;
    cursor: default;
  }
`;

export default props => {
  const { submitEnabled } = useContext(Form.Context);
  return (
    <NextButton disabled={!submitEnabled} {...props}>
      Next
    </NextButton>
  );
};
